// extracted by mini-css-extract-plugin
export default {"form":"ConfirmEmail_form__KhYEF","titleWrapper":"ConfirmEmail_titleWrapper__JJYNY","title":"ConfirmEmail_title__iO7Ru","button":"ConfirmEmail_button__UVGGJ"};